<template>
    <div>

    <section class="service d-flex align-items-center">
        <div class="container py-5">
            
        </div>
    </section>

    <section class="py-4">
        <div class="container">
            <div class="p-4">                
                <h5 class="fw-bold mb-2"><span style="color:var(--brand)">SERVICES</span></h5>                
                <div class="d-flex justify-content-start" style="padding-top: 20px;">
                    <p class="mb-0">Engineering and surveyor focus on land development projects:</p>                    
                </div>                                                               
                <div class="d-flex justify-content-start" style="padding-top: 16px;">                    
                    <ul>
                        <li>Due diligence on site development issues</li>
                        <li>Engineering detail designs for land development projects</li>
                        <li>Storm retention analysis</li>
                        <li>Sanitary study</li>                        
                        <li>Contract administration</li>                            
                    </ul>                    
                </div>
                <div class="d-flex justify-content-start" style="padding-top: 20px;">
                    <p class="mb-0">We also arrange survey services, geotechnical investigation service, environmental assessment service, traffic impact assessment service and planning service for our clients.</p>
                </div>
            </div>             
        </div>
    </section>

    </div>
</template>


<script setup>


</script>


<style scoped>

</style>